module.exports = "<div ng-class=\"{'dropdown-opened': $ctrl.isDropdownOpened}\" class=\"custom-dropdown\">\n\t<button ng-click=\"$ctrl.toggleDropDown()\" class=\"dropdown-head\">{{$ctrl.choosenItem}}</button>\n\t<ul class=\"dropdown-body\">\n\t\t<li class=\"dropdown-body__item\" ng-repeat=\"listItem in $ctrl.list track by $index\" ng-click=\"$ctrl.chooseDropDownItem(listItem)\">\n\t\t\t<span role=\"button\">{{listItem}}</span>\n\t\t</li>\n\t</ul>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dropdown/dropdown.html
// module id = 259
// module chunks = 0